export const instructionsPagesUrlList = ['login-psw', 'login-no-psw', 'cancel', 'login', 'main'];
